<ng-container *ngIf="control">
  <span class="error" *ngIf="control.invalid && control.touched">
    <!-- <ng-container *ngIf="control.errors?.['required']">
      *This field is required.
    </ng-container> -->
    <ng-container *ngIf="control.errors?.['pattern']">
      *{{ messageConstant[inputData!.key].pattern }}
    </ng-container>
    <ng-container *ngIf="control.errors?.['confirmPasswordValidator']">
      *{{ messageConstant[inputData!.key].confirmPasswordValidator }}
    </ng-container>
    <!-- <ng-container *ngIf="control.errors?.['minlength']">
        *{{ messageConstant[inputData.key].minlength }}
      </ng-container>
      <ng-container *ngIf="control.errors?.['maxlength']">
        *{{ messageConstant[inputData.key].maxlength }}
      </ng-container> -->
  </span>
</ng-container>
